/// <amd-module name="Wit/WorkItemForm/Details/index" />
export * from './WorkItemFormTab';
